import { component } from 'picoapp';
import ScrollBooster from 'scrollbooster';
import { clear } from 'utils/node';
import { image } from 'utils/image';
import ClerkHelper from 'utils/clerk';

export default component((node, ctx) => {
  const { upsellCollectionId } = node.dataset;
  const clerk = new ClerkHelper(['Cart Recommendations'], 10);
  const itemsWrapper = node.querySelector('[data-items-wrapper]');
  const items = node.querySelector('[data-items]');

  // eslint-disable-next-line no-new
  new ScrollBooster({
    viewport: itemsWrapper,
    content: items,
    bounce: false,
    scrollMode: 'native',
    direction: 'horizontal',
    onPointerDown: () => {
      itemsWrapper.classList.add('dragging');
    },
    onPointerUp: () => {
      itemsWrapper.classList.remove('dragging');
    },
  });

  const drawerHolder = document.createElement('div');
  drawerHolder.setAttribute('data-recommendation-list', '');
  document.body.appendChild(drawerHolder);

  const fetchProducts = async () => clerk.getProducts('recommendations/category/popular', {
    category: upsellCollectionId,
  });

  const renderVariants = ({ variants }) => {
    let html = '';

    const selectedOrFirst = variants.filter((item) => item.available);

    variants.forEach((item) => {
      const { available, id, title } = item;

      const soldOut = !available ? 'sold-out' : '';
      const disabled = !available ? 'disabled' : '';

      const titleParts = title.split(' / ');
      const variant = titleParts[titleParts.length - 1].split('_');
      const size = variant[variant.length - 1];

      const checked = selectedOrFirst[0].id === id ? 'checked' : '';

      html += `
        <label class="product__form-label ${soldOut}">
          <input class="peer sr-only" type="radio" name="id" ${checked} ${disabled} value="${id}">
          <span class="text-sm text-center font-medium flex-grow flex cursor-pointer justify-center items-center border border-grey-border hover:border-black peer-checked:bg-black peer-checked:text-white peer-checked:border-black transition-colors duration-300">${size}</span>
        </label>
      `;
    });

    return html;
  };

  const renderProducts = ({ products }) => {
    clear(items);
    clear(drawerHolder);

    products.forEach((item) => {
      const drawerId = `recommendation-${item.id}`;
      const [title, size, gender] = item.title.split(' | ');

      const renderTitleMeta = () => (size && gender ? `<p class="mt-1 text-grey-border text-xs">${size} - ${gender}</p>` : '');
      const truncateDescription = () => (item.description ? item.description.split('\n')[0] : '');

      items.insertAdjacentHTML('beforeend', `
        <div class="flex flex-col text-sm text-center" data-component="CartRecommendationItem" data-clerk-product-id="${item.id}">
          <div class="w-32 flex flex-col flex-grow">
            <div class="aspect-ratio aspect-ratio--4/5 bg-grey">
              ${image({ src: item.image.src, width: 300, height: 300 }, '!object-contain p-2', false)}
            </div>

            <p class="mt-3">${title}</p>
            ${renderTitleMeta()}

            <p class="mt-auto"><strong>+ ${Shopify.formatMoney(item.price * 100, theme.moneyFormat)}</strong></p>
            <button class="btn btn--border btn--small w-full font-normal justify-center mt-3" type="button" data-trigger="${drawerId}">${window.theme.strings.add}<button>
          </div>
        </div>
      `);

      drawerHolder.insertAdjacentHTML('beforeend', `
        <form class="drawer drawer--right p-4 lg:p-6 rounded-none"
          action="${window.theme.routes.cartAdd}"
          method="POST"
          data-drawer="${drawerId}"
          data-modal="true"
          aria-hidden="true"
          data-clerk-product-id="${item.id}">

          <input type="hidden" name="quantity" value="1" />

          <header class="flex flex-wrap items-center pb-6">
            <button class="flex flex-wrap items-center hover:text-accent duration-200" type="button" data-close>
              <span class="w-3 h-3 mr-3 pointer-events-none">${window.theme.icons.close}</span>
              <p class="pointer-events-none">${window.theme.strings.close}</p>
            </button>
          </header>

          <div class="flex-1 scrollable">
            <h3>${item.title}</h3>

            <div class="aspect-ratio aspect-ratio--4/5 bg-grey my-6">
              ${image(item.image, '!object-contain p-2', 2 / 3)}
            </div>

            <div class="space-y-4">
              <p><strong>${window.theme.strings.product.selectSize}</strong></p>

              <div class="flex flex-wrap gap-3">
                ${renderVariants(item)}
              </div>
            </div>

            <div class="rte mt-6">
              ${truncateDescription(item.description)}
            </div>
          </div>

          <footer class="mt-4">
            <button class="btn btn--black btn--center w-full" type="submit">${window.theme.strings.addToCart}</button>
          </footer>
        </form>
      `);
    });

    window.Clerk('click', '*[data-clerk-product-id]');
  };

  const init = async () => {
    const products = await fetchProducts();

    renderProducts(products);
    document.dispatchEvent(new CustomEvent('app:mount'));
  };

  setTimeout(() => {
    init();
  }, 500);

  ctx.on('cart:updated', async () => {
    const products = await fetchProducts();
    renderProducts(products);
  });
});
